<template>
  <div>
    <el-form
      :model="invite"
      status-icon
      :rules="formRules"
      ref="cloudUserInvite"
      label-width="120px"
      label-position="left"
      size="mini"
      :inline-message="true"
    >
      <el-form-item label="Tip pravice" prop="cloudPermission">
        <el-select v-model="invite.cloudPermission" placeholder="Izberite tip pravice" style="width: 100%;">
          <el-option
            v-for="item in permissions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <span style="float: left;">{{ item.label }}</span>
            <span
              style="float: right; margin-left:20px; color:#606266; font-weight: normal">{{ item.description }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="E-mail" prop="email">
        <el-input type="text" v-model="invite.email" autocomplete="off">
        </el-input>
      </el-form-item>
      <el-form-item style="text-align: right;">
        <el-button type="primary" class="gumb-potrdi" @click="inviteUser()" :loading="loading">
          Povabi
        </el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import {Select, Option, Form, FormItem, Input, Button} from 'element-ui'
import {CloudProject} from '../../../../../assets/js/T2Cloud/CloudProject'

export default {
  name: 'CloudUserInvite',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    project: {
      type: CloudProject,
      required: true
    }
  },
  data () {
    return {
      invite: {
        cloudPermission: null,
        email: ''
      },
      formRules: {
        email: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'blur'},
          {validator: this.formValidation.inputEmailValidation, trigger: 'blur'}
        ],
        cloudPermission: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'blur'},
          {validator: this.formValidation.inputNotNullValidation, trigger: 'blur'}
        ]
      },
      permissions: [],
      loading: false
    }
  },
  created () {
    if (this.project.owner) {
      this.permissions.push(
        {
          label: 'Skrbnik',
          value: 'OPEN_STACK_PROJECT_MAINTAINER',
          description: 'lahko povabi druge osebe'
        }
      )
    }
    if (this.project.maintainer) {
      this.permissions.push(
        {
          label: 'Uporabnik',
          value: 'OPEN_STACK_PROJECT_USER',
          description: 'lahko kreira enega cloud uporabnika'
        }
      )
    }
  },
  methods: {
    async inviteUser () {
      this.$refs['cloudUserInvite'].validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            await this.project.inviteUserToProject(this.invite.cloudPermission, this.invite.email)
            this.ShowSuccessMessage({message: 'Povabilo uspešno poslano'})
            this.loading = false
            this.$emit('invitationSent', this.invite.cloudPermission, this.invite.email)
          } catch (e) {
            this.ShowErrorMessage({message: e.message})
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/T2Cloud/CloudUserInvite.vue